export default __webpack_public_path__ + "static/media/shield.82b2da77.svg";